export const wsAddress = "wss://service.figurait.ru:8686";